import React, { Component } from 'react';
import defaultImage from '../../assets/default.jpg';
import moment from 'moment';
import {Link} from 'react-router-dom';
import {getStatus} from '../../misc/misc';

export default ({listEvent, baseURL}) => {

  return (
    <section className="psre-tiga-satu">
      <div className="container">
        <table className="table-borderless w-100 mb-5">
          <tr>
            <td>
              <p className="mb-0" style={{fontSize: '14px', fontWeight: '600'}}>Acara dari PSrE</p>
            </td>
            <td className="tb" style={{width: '65%'}}>
              <div style={{borderTop: '1px solid rgba(49, 49, 49, 0.12)', width:  '100%'}}></div>
            </td>
            <td class="text-right">
              <Link to='/event/all' style={{fontSize: '13px', fontWeight: '600', color: "#0085C7"}}>Lihat Semua Acara</Link>
            </td>
          </tr>
        </table>
        <div className="row" style={{flexWrap: 'wrap', overflowX: 'auto'}}>
          {listEvent.length ? listEvent.map(e => (
            <div className="col-lg-4 col-md-4 col-sm-10 col-10">
              <img className="mb-4" src={e.picture ? baseURL+'/'+e.picture : defaultImage} alt="grey" style={{width: '100%', height: '150px', objectFit: 'cover'}} />
              <div className="d-flex">
                <div className="text-center">
                  <p style={{fontSize: '18px', color: '#15A325', fontWeight: '600'}}>{moment(e.startDate).format('MMMM')}</p>
                  <p style={{fontSize: '18px', fontWeight: '600'}}>{moment(e.startDate).format('DD')}</p>
                </div>
                <div className="ml-5">
                  <Link to={`/event_detil/${e._id}`} style={{color: 'black'}}>
                    <p style={{fontSize:'18px', fontWeight: '600'}}>{e.title}</p>
                  </Link>
                  <p className="text-muted">{moment(e.startDate).format('ddd, MMMM DD')}, {e.startTime}</p>
                  <p className="text-muted">{e.location}</p>
                  <p style={{fontSize: '16px', fontWeight: '600'}}>{getStatus(e.endDate)}</p>
                </div>
              </div>
            </div>
          )) : <div>No data founded</div>}
        </div>
      </div>
    </section>
  )
}
